class NextAppointmentDatestepperCtrl {
    constructor(NextAppointmentApi, slicesService, notificationService, DoclrModalService, userContext) {
        'ngInject';

        this.NextAppointmentApi = NextAppointmentApi;
        this.slicesService = slicesService;
        this.notificationService = notificationService;
        this.DoclrModalService = DoclrModalService;
        this.userContext = userContext;
    }

    $onInit() {

    }

    searchNextAppointment() {
        this.NextAppointmentApi.searchNextAppointment(this._createNextAppointmentCriteria())
            .then(appointment => this._onAppointmentGet(appointment));
    }

    searchNextAppointmentToday() {
        let nextAppointmentCriteria = this._createNextAppointmentCriteria();
        nextAppointmentCriteria.fromDay = moment().format("YYYY-MM-DD");
        this.NextAppointmentApi.searchNextAppointment(nextAppointmentCriteria)
            .then(appointment => this._onAppointmentGet(appointment));
    }

    searchNextAppointmentInPractice() {
        let nextAppointmentCriteria = this._createNextAppointmentCriteria();
        nextAppointmentCriteria.calendarId = undefined;
        this.NextAppointmentApi.searchNextAppointment(nextAppointmentCriteria)
            .then(appointment => this._onAppointmentGet(appointment, true));
    }

    searchNextAppointmentInPracticeToday() {
        let nextAppointmentCriteria = this._createNextAppointmentCriteria();
        nextAppointmentCriteria.calendarId = undefined;
        nextAppointmentCriteria.fromDay = moment().format("YYYY-MM-DD");
        this.NextAppointmentApi.searchNextAppointment(nextAppointmentCriteria)
            .then(appointment => this._onAppointmentGet(appointment, true));
    }

    searchAvailability() {
        this.DoclrModalService.openModal('/partials/components/nextappointment/nextappointment.picker.modal.html',
            NextAppointmentModalCtrl, undefined, 'lg');
    }

    _onAppointmentGet(appointment, isPractice) {
        if (appointment) {
            this.notificationService.showSuccess(doclrVertaal.instant('nextappointment.result.afspraak') + ' ' + moment(appointment.day).format('DD-MM-YYYY') + " " + doclrVertaal.instant('nextappointment.result.om') + " " + appointment.start + doclrVertaal.instant('nextappointment.result.u'));
            this._navigateTo(appointment, isPractice);
        } else {
            this.notificationService.showWarning(doclrVertaal.instant('nextappointment.result.geen.afspraken'));
        }
    }

    _createNextAppointmentCriteria() {
        return {
            discipline: undefined,
            fromDay: this.slicesService.slicesLoader.criteria.dag,
            calendarId: this._getCalendarId(),
            appointmentType: undefined
        };
    }

    _navigateTo(appointment, isPractice) {
        if (appointment) {
            if (isPractice) {
                this.slicesService.slicesLoader.navigator.naarDagModus(appointment.day, appointment.appointmentId)
            } else {
                this.slicesService.slicesLoader.navigator.wijzigDag(appointment.day, appointment.appointmentId)
            }
        }

    }

    _getCalendarId() {
        if (this.slicesService.slicesLoader.criteria.agendaOrResource) {
            return this.slicesService.slicesLoader.criteria.agendaOrResource.uuid;
        }
        return undefined;
    }
}

(function () {
    'use strict';

    angular.module('doclr.components',)
        .component('nextAppointmentDatestepper', {
            templateUrl: '/partials/components/nextappointment/nextappointmentdatestepper.html',
            controller: NextAppointmentDatestepperCtrl,
            controllerAs: 'NextAppointmentDatestepperCtrl'
        });
})();